// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bb56cd8e","732":"f724dd57","977":"691ab79e"}[chunkId] + ".chunk.js";
};